import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import API from "../../api";
import { capture } from "../../instrument";
import { getSetting } from "../../queries/setting";

const PatientEmailsSection = () => {
  const queryClient = useQueryClient();
  const [sesIdentityDraft, setSesIdentityDraft] = useState(null);

  const { data: setting } = useQuery({ queryKey: ["setting"], queryFn: getSetting });

  const sesIdentityMutation = useMutation({
    mutationFn: (sesIdentity) => API.post("/setting", { sesIdentity }),
    onSuccess: ({ data }) => {
      queryClient.setQueryData(["setting"], data);
      setSesIdentityDraft(null);
      toast.success("Identité d'envoi mise à jour");
    },
    onError: (error) => {
      capture(error);
      toast.error(error.message || "Erreur d'enregistrement de l'identité d'envoi");
    },
  });

  const sesIdentity = sesIdentityDraft ?? setting?.sesIdentity ?? "";

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-2xl font-semibold tracking-tight text-gray-900">Emails patients</h2>
        <p className="mt-1.5 text-sm text-gray-500">Réglages des emails envoyés aux patients depuis leurs dossiers.</p>
      </div>

      {!setting && (
        <div className="flex justify-center py-16">
          <div className="size-5 animate-spin rounded-full border-2 border-gray-300 border-t-primary-500" />
        </div>
      )}

      {setting && (
        <div className="overflow-hidden rounded-xl bg-white shadow-[0_1px_2px_rgba(0,0,0,0.05)] ring-1 ring-gray-950/[0.06]">
          <form
            className="flex flex-wrap items-center justify-between gap-x-6 gap-y-2 px-4 py-3.5"
            onSubmit={(e) => {
              e.preventDefault();
              sesIdentityMutation.mutate(sesIdentity.trim());
            }}
          >
            <div className="min-w-0 flex-1 basis-60">
              <label htmlFor="ses-identity" className="text-[13px] font-medium text-gray-900">
                Adresse expéditeur
              </label>
              <p className="mt-0.5 text-[13px] text-gray-500">Adresse SES vérifiée utilisée pour les emails aux patients. Vide : noreply@querco.co.</p>
            </div>
            <div className="flex shrink-0 items-center gap-2">
              <input
                id="ses-identity"
                name="sesIdentity"
                type="email"
                placeholder="noreply@querco.co"
                value={sesIdentity}
                onChange={(e) => setSesIdentityDraft(e.target.value)}
                className="h-8 w-64 rounded-md border border-transparent bg-gray-100 px-2.5 text-[13px] text-gray-900 outline-none transition-colors placeholder:text-gray-400 hover:bg-gray-200/70 focus:border-primary-500 focus:bg-white focus:ring-2 focus:ring-primary-500/20"
              />
              <button
                type="submit"
                disabled={sesIdentityMutation.isPending || sesIdentity === (setting.sesIdentity ?? "")}
                className="h-8 rounded-md bg-white px-3 text-[13px] font-medium text-gray-700 shadow-sm ring-1 ring-gray-950/10 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
              >
                Enregistrer
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default PatientEmailsSection;
